<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  <!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">

        <div class="card rounded-5 border-0">
          <div class="card-body mx-3 my-3 bg-white rounded-5">
            <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
              <h5 class="fw-500 mb-0">Purchased Tickets</h5>

              <!-- Export (disabled when empty) -->
              <button
                @click="exportTicketsToCSV"
                class="btn btn-primary btn-sm text-xxs"
                :disabled="!event_ticket_instances?.length"
                :aria-disabled="!event_ticket_instances?.length"
                title="Export visible tickets to CSV"
              >
                Export to CSV
              </button>
            </div>

            <!-- Table only if there is data -->
            <div v-if="event_ticket_instances && event_ticket_instances.length" class="table-responsive">
              <table class="table align-middle table-striped table-borderless mb-0">
                <thead class="text-uppercase small btn-primary text-white text-xxs">
                  <tr>
                    <th class="text-center">#</th>
                    <th class="text-center">First Name</th>
                    <th class="text-center">Last Name</th>
                    <th class="text-center">Email</th>
                    <th class="text-center">Event Name</th>
                    <th class="text-center">Ticket Name</th>
                    <th class="text-center">Ticket Code</th>
                    <th class="text-center">Redeemed</th>
                    <th class="text-center">Purchased At</th>
                    <th class="text-center">Redeemed At</th>
                  </tr>
                </thead>
                <tbody class="text-xxs">
                  <tr
                    v-for="(instance, index) in event_ticket_instances"
                    :key="instance.id"
                    class="border-bottom"
                  >
                    <td class="text-center">
                      <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 small">
                        {{ index + 1 }}
                      </span>
                    </td>
                    <td class="text-center">{{ instance.first_name }}</td>
                    <td class="text-center">{{ instance.last_name }}</td>
                    <td class="text-center">{{ instance.email }}</td>
                    <td class="text-center">{{ instance.event_name }}</td>
                    <td class="text-center">{{ instance.ticket_name }}</td>
                    <td class="text-center">{{ instance.unique_code }}</td>
                    <td class="text-center">
                      <span
                        class="badge"
                        :class="instance.is_redeemed ? 'bg-success' : 'bg-secondary'"
                      >
                        {{ instance.is_redeemed ? 'Yes' : 'No' }}
                      </span>
                    </td>
                    <td class="text-center">{{ newFormatDate(instance.order_date) }}</td>
                    <td class="text-center">
                      {{ instance.updated_at ? newFormatDate(instance.updated_at) : 'N/A' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Desktop empty state -->
            <div v-else class="text-center py-5">
              <i class="bi bi-ticket-perforated display-1 text-muted mb-3" aria-hidden="true"></i>
              <p class="text-muted fs-5 mb-2">No tickets purchased yet.</p>
              <p class="text-muted text-xxs mb-3">When tickets are purchased, they will appear here.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
